import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';

import PeopleToContactContent from './PeopleToContactContent.connect';

export const PeopleToContactReport = (props: any) => {
  const filterName = props?.filterName || props?.modalProps?.filterName;
  return (
    <RecordsScreen
      contentComponent={PeopleToContactContent}
      contentProps={{filterName}}
    />
  );
};
